export const FeatureName = {
  ApplePay: "ApplePay",
} as const;

export type FeatureNameType = (typeof FeatureName)[keyof typeof FeatureName];
